export const desc = [
  {
    imgPath: '3.avif',
    desc: 'Round 2 of Replicon'
  },
  {
    imgPath: '25_1.avif',
    desc: 'Speaker at Agentic AI Workshop'
  },
  {
    imgPath: '25_0.avif',
    desc: 'Students at Agentic AI Workshop'
  },
  {
    imgPath: '2_land.avif',
    desc: 'Round 2 of Code Surge'
  },
  {
    imgPath: 'eval4.jpg',
    desc: 'Evaluation at Round 2 of Webathon 3.0'
  },
  {
    imgPath: 'eval3.jpg',
    desc: 'Evaluation at Round 2 of Webathon 3.0'
  },
  {
    imgPath: 'eval1.jpg',
    desc: 'Evaluation at Round 2 of Webathon 3.0'
  },
  {
    imgPath: '24_5.jpg',
    desc: 'Participants at Webathon 3.0'
  },
  {
    imgPath: 'eval2.jpg',
    desc: 'Evaluation at Round 2 of Webathon 3.0'
  },
  {
    imgPath: 'web_winners.jpg',
    desc: 'Winners at Webathon 3.0'
  },
  {
    imgPath: 'winner1.png',
    desc: 'Webathon 3.0 Prize Distribution'
  },
  {
    imgPath: 'winner2.png',
    desc: 'Webathon 3.0 Prize Distribution'
  },
  {
    imgPath: 'winner3.png',
    desc: 'Webathon 3.0 Prize Distribution'
  },
  {
    imgPath: 'winner4.png',
    desc: 'Webathon 3.0 Prize Distribution'
  },
  {
    imgPath: '24_10.jpg',
    desc: 'Round 1 of Webathon 3.0'
  },
  {
    imgPath: 'winner5.png',
    desc: 'Webathon 3.0 Prize Distribution'
  },
  {
    imgPath: 'image18.png',
    desc: 'Speaker at the Web 3.0 Lecture'
  },
  {
    imgPath: 'stack1.jpg',
    desc: 'Speakers at Stack Track'
  },
  {
    imgPath: '24_4.jpg',
    desc: 'Mentimeter Quiz Round at Stack Track'
  },
  {
    imgPath: '24_2.jpg',
    desc: 'Stack Track at APJ Abdul Kalam Auditorium'
  },
  {
    imgPath: '25_2.avif',
    desc: 'Inauguration Ceremony at AI Hack Day'
  },
  {
    imgPath: '25_7.avif',
    desc: 'Speaker at Tech Spectrum'
  },
  {
    imgPath: '25_3.avif',
    desc: 'AI Hack Day Event'
  },
  {
    imgPath: '25_6.avif',
    desc: 'Speaker at Tech Spectrum'
  },
  {
    imgPath: 'techspec1 (1).webp',
    desc: 'Participants at Tech Spectrum'
  },
  {
    imgPath: 'techspec3.JPG',
    desc: 'Speaker at Tech Spectrum'
  },
  {
    imgPath: 'techspec1 (2).webp',
    desc: 'Speaker at Tech Spectrum'
  },
  {
    imgPath: '25_5.avif',
    desc: ' Winter Coding Contest 4.0 Event'
  },
  {
    imgPath: '25_4.avif',
    desc: 'Round 2 Participants at Winter Coding Contest 4.0'
  },
  {
    imgPath: 'wcc4_vol.jpg',
    desc: 'Volunteers at Winter Coding Contest 4.0'
  },
  {
    imgPath: '24_1.webp',
    desc: 'Winners at Winter Coding Contest 4.0'
  },
  {
    imgPath: '24_0 (1).JPG',
    desc: 'Participants at Winter Coding Contest 4.0'
  },
  {
    imgPath: '24_0 (2).jpg',
    desc: 'Winter Coding Contest 4.0 at KS Auditorium'
  },
  {
    imgPath: 'cb1.jpg',
    desc: 'Participants at Coding Blitz'
  },
  {
    imgPath: 'cb2.jpg',
    desc: 'Participants at Coding Blitz'
  },
  {
    imgPath: 'cb5.jpg',
    desc: 'Participants at Coding Blitz'
  },
  {
    imgPath: 'ws3.jpg',
    desc: 'Websculpt Event'
  },
  {
    imgPath: 'ws1.jpg',
    desc: 'Volunteers at Websculpt'
  },
  {
    imgPath: 'ws2.jpg',
    desc: 'Participants at Websculpt'
  },
  {
    imgPath: '25_15.jpg',
    desc: 'Speaker at Come Become a Coder'
  },
  {
    imgPath: '25_20.avif',
    desc: 'Round 2 of Webathon 2.0'
  },
  {
    imgPath: '25_19.avif',
    desc: 'Round 1 of Webathon 2.0'
  },
  {
    imgPath: 'image25.jpg',
    desc: 'The Winners of Webathon'
  },
  {
    imgPath: 'image8.jpg',
    desc: 'Winners of Webathon'
  },
  {
    imgPath: '25_18.jpg',
    desc: 'Talk Session'
  },
  {
    imgPath: '25_17.avif',
    desc: 'Participants in Machine Learning Workshop'
  },
  {
    imgPath: '25_13.jpg',
    desc: 'Speaker at Coding 101'
  },
  {
    imgPath: 'coding101_3 (1).jpg',
    desc: 'Coding 101 Event at KS Auditorium'
  },
  {
    imgPath: '25_16.avif',
    desc: 'Guest Speaker at Illuminaire'
  },
  {
    imgPath: 'illum1.jpg',
    desc: 'Speaker at Illuminare'
  },
  {
    imgPath: 'illum3.jpg',
    desc: 'Speaker at Illuminare'
  },
  {
    imgPath: 'illum5.jpg',
    desc: 'Speaker at Illuminare'
  },
  {
    imgPath: 'image10.jpg',
    desc: 'Winners of Winter Coding Contest 3.0'
  },
  {
    imgPath: 'image1.jpg',
    desc: 'Volunteers at WCC 3.0'
  },
  {
    imgPath: 'illum2.jpg',
    desc: 'Speakers at Induction Program(2024)'
  },
  {
    imgPath: 'image14.png',
    desc: 'Students Presenting to the Jury at Webathon'
  },
  {
    imgPath: 'image44.png',
    desc: 'Winners of Winter Coding Contest 2.0'
  },
  {
    imgPath: 'image37.jpg',
    desc: 'Participants at Winter Coding Contest 2.0'
  },
  {
    imgPath: 'image28.jpg',
    desc: 'Inauguration of the Deep Learning Workshop'
  },
  {
    imgPath: 'image9.jpg',
    desc: 'Speakers at Python Workshop Conducted for 1st Years'
  },
  {
    imgPath: 'promo_1.jpeg',
    desc: 'Principal Dr. C.D. Naidu Garu at the Promotional Event'
  },
  {
    imgPath: 'image27.jpg',
    desc: 'Students at the TECH360 Event'
  },
  {
    imgPath: 'image21.jpg',
    desc: 'Speakers at TECH360 Event'
  },
  {
    imgPath: 'image29.jpg',
    desc: 'Students at the PySpace Event'
  },
  {
    imgPath: 'image19_re.jpg',
    desc: 'Introducing ACM VNRVJIET to the Freshers'
  },
  {
    imgPath: 'image24.jpg',
    desc: 'The Code Spree Coding Contest'
  },
  {
    imgPath: 'talk.jpg',
    desc: 'Guest Speaker'
  },
  {
    imgPath: 'cb4.jpg',
    desc: 'Speaker at Induction Program(2024)'
  },
];